import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api.js'
import {
  useNotifications,
  notifyError,
  notifySuccess,
} from 'Logic/Notifications.js'

export default function useDataOnSubmit() {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  return async function onSubmit() {
    try {
      if (!window.confirm(`Are you sure?`)) return

      let mutationResponse = await executeMutation()
      if (mutationResponse.error) {
        notify(notifyError(mutationResponse.error.message))
      } else {
        if (mutationResponse.data?.result?.ok) {
          notify(notifySuccess(`Onboarding input log saved`))
        } else {
          notify(
            notifyError(
              'There was an error performing the data import. Please check the Logs table.'
            )
          )
        }
      }
    } catch (error) {
      notify(notifyError(error.message))
    }
  }
}
